import { render, staticRenderFns } from "./FullFooter.vue?vue&type=template&id=5f8ed7f5&scoped=true&"
import script from "./FullFooter.vue?vue&type=script&lang=js&"
export * from "./FullFooter.vue?vue&type=script&lang=js&"
import style0 from "./FullFooter.vue?vue&type=style&index=0&id=5f8ed7f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ed7f5",
  null
  
)

export default component.exports